<template>
  <van-row v-for="item in datas" :key="item.name" gutter="24" class="keyValRow">
    <van-col span="5">
      <div class="name">{{ item.name }}</div>
    </van-col>
    <van-col span="19">
      <div class="val" v-html="item.value"></div>
    </van-col>
  </van-row>
</template>

<script>
import { reactive, toRefs } from 'vue'

export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const state = reactive({
      datas
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.name {
  display: inline-block;
  width: 100%;
  text-align: justify;
  color: #666666;
}
.name:after {
  content: '';
  display: inline-block;
  width: 100%;
}
.val {
  text-align: justify;
  color: #333333;
}
.keyValRow {
  :deep(.van-col) {
    max-height: 500px !important;
  }
}
</style>
